import "./App.css";
import React, { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Screen404 from "./views/404";
import OnboardingScreen from "./views/Onboarding";
import OrderScreen from "./views/Order";
import ProductDetailsScreen from "./views/ProductDetails";
import { createTheme, darken } from "@material-ui/core/styles";
import { ThemeProvider } from "@emotion/react";
import SearchScreen from "./views/Search";
import CartScreen from "./views/Cart";
import { connect } from "react-redux";
import HistoryScreen from "./views/History";
import SendOTPScreen from "./views/SendOTP";
import VerifyOTPScreen from "./views/VerifyOTP";
import CompleteProfileScreen from "./views/CompleteProfile";
import { grey } from "@mui/material/colors";
import HistoryDetailScreen from "./views/HistoryDetail";
import OrderSuccess from "./views/OrderSuccess";
import ItemDetails from "./views/ItemDetails";
import Payment from "./views/Payment";
import Success from "./views/Success";
import ReviewList from "./views/ReviewList";
import QrisUr from "./views/QrisUr";
import CreateReviewScreen from "./views/CreateReview";
import { MembershipScreen } from "./views/Membership";
import OrderReceivedScreen from "./views/OrderReceived";
import { getSelfOrderTheme } from "./services/SelforderTheme";
import { CircularProgress, Typography, Box, CssBaseline } from "@mui/material";
import NotFound from "./views/404";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const FONT_CONFIG = {
  Omnes: [
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Omnes-Medium.ttf", weight: 400 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Omnes-Regular.ttf", weight: 300 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Omnes-SemiBold.ttf", weight: 500 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Omnes-Bold.ttf", weight: 700 },
  ],

  HelveticaNeue: [
    { url: "https://ik.imagekit.io/natta/assets/Fonts/HelveticaNeueLight.otf", weight: 300 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/HelveticaNeueRegular.otf", weight: 400 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/HelveticaNeueMedium.otf", weight: 500 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/HelveticaNeueBold.otf", weight: 700 },
  ],

  Cooper: [
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Cooper-Regular.ttf", weight: 300 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Cooper-Medium.ttf", weight: 400 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Cooper-SemiBold.ttf", weight: 500 },
    { url: "https://ik.imagekit.io/natta/assets/Fonts/Cooper-Bold.ttf", weight: 700 },
  ],
};

function setFavicon(url) {
  // hapus semua favicon lama
  const links = document.querySelectorAll("link[rel*='icon']");
  links.forEach(link => link.remove());

  // buat favicon baru
  const newLink = document.createElement("link");
  newLink.rel = "icon";
  newLink.type = "image/png";

  // 🔥 anti cache
  newLink.href = url + "?v=" + new Date().getTime();

  document.head.appendChild(newLink);
}

function loadFontFamily(fontName) {
  const id = `font-${fontName}`;

  // skip kalau sudah ada
  if (document.getElementById(id)) return;

  const fonts = FONT_CONFIG[fontName];
  if (!fonts) return;

  const style = document.createElement("style");
  style.id = id;

  style.innerHTML = fonts
    .map(
      (f) => `
        @font-face {
          font-family: '${fontName}';
          src: url('${f.url}') format('truetype');
          font-weight: ${f.weight};
          font-style: normal;
          font-display: swap;
        }
      `
    )
    .join("");

  document.head.appendChild(style);
}

function loadGoogleFont(fontFamily) {
  const id = "dynamic-font";

  const old = document.getElementById(id);
  if (old) old.remove();

  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(
    / /g,
    "+"
  )}:wght@300;400;500;700&display=swap`;

  document.head.appendChild(link);
}

const getPartnerId = () => {
  const urlPartner = new URLSearchParams(window.location.search).get("partnerID");
  const lsPartner = localStorage.getItem("partnerID");

  let partner_id = null;

  // ✅ PRIORITAS 1: dari URL (hasil scan QR)
  if (urlPartner) {
    partner_id = urlPartner;

    // sync ke localStorage biar konsisten
    localStorage.setItem("partnerID", JSON.stringify(urlPartner));
  } 
  // ✅ PRIORITAS 2: fallback ke localStorage
  else if (lsPartner) {
    try {
      partner_id = JSON.parse(lsPartner);
    } catch {
      partner_id = null;
    }
  }

  // ❗ kalau dua-duanya ga ada
  if (!partner_id) {
    window.location.href = "/404";
    return null;
  }

  return partner_id;
};

class App extends Component {
  state = {
    primaryColor: "#1fb0e6", // default fallback
    fontFamily: "Rubik",
    logo: null,
    isReady: false
  };
  async componentDidMount() {
    await this.initTheme();
  }

  initTheme = async () => {
  // ⛔ STOP kalau lagi di halaman 404
  if (window.location.pathname === "/404") {
    this.setState({ isReady: true });
    return;
  }

  const partner_id = getPartnerId();

  if (!partner_id) {
    this.setState({
      isReady: true,
      isInvalidPartner: true
    });
    return;
  }

  try {
    const res = await getSelfOrderTheme(partner_id);

    if (res && res.success === 1 && res.theme) {
      const themeData = res.theme;

      if (themeData.font_style) {
        const fontName = themeData.font_style.split(",")[0];

        if (FONT_CONFIG[fontName]) {
          loadFontFamily(fontName);
        } else {
          loadGoogleFont(themeData.font_style);
        }
      }

      this.setState({
        primaryColor: themeData.hex_color || "#1fb0e6",
        fontFamily: themeData.font_style || "Rubik",
        logo: themeData.logo || null,
        isReady: true
      });

      if (themeData.logo) {
        setFavicon(themeData.logo);
      }
    } else {
      throw new Error("Theme not ready");
    }

  } catch (err) {
    console.log("retry theme...");

    setTimeout(() => {
      this.initTheme();
    }, 1000);
  }
};

  render() {
    const { primaryColor, fontFamily, logo, isReady } = this.state;

    const theme = createTheme({
      palette: {
        primary: {
          main: primaryColor,
          dark: darken(primaryColor, 0.2)
        },
        white: { main: "#ffffff" },
        black: { main: "#000000" },
        red: { main: "#D22B2B" },
        grey: grey
      },
      typography: {
        fontFamily: fontFamily,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700
      },
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            body: {
              fontFamily: fontFamily
            }
          }
        }
      },
      custom: {
        logo: logo
      }
    });

    // ⛔ Jangan render dulu sebelum theme ready
    if (!isReady) {
      return (
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2
          }}
        >
          <CircularProgress />
          <Typography variant="body1">
            Retrieving data...
          </Typography>
        </Box>
      );
    }

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <React.Suspense fallback={loading}>
            <Routes>
              <Route path="/" element={<OnboardingScreen />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="/order" element={<OrderScreen />} />
              <Route path="/auth" element={<SendOTPScreen />} />
              <Route path="/verify-otp" element={<VerifyOTPScreen />} />
              <Route path="/history" element={<HistoryScreen />} />
              <Route path="/history-detail" element={<HistoryDetailScreen />} />
              <Route
                path="/complete-profile"
                element={<CompleteProfileScreen />}
              />
              <Route
                path="/product-details"
                element={<ProductDetailsScreen />}
              />
              <Route path="/item-details" element={<ItemDetails />} />
              <Route path="/search" element={<SearchScreen />} />
              <Route path="/cart" element={<CartScreen />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/success" element={<Success />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/review-list" element={<ReviewList />} />
              <Route path="/qris-ur" element={<QrisUr />} />
              <Route path="/create-review" element={<CreateReviewScreen />} />
              <Route path="/membership" element={<MembershipScreen />} />
              <Route path="/order-received" element={<OrderReceivedScreen />} />
              <Route
                path="/404"
                element={(props) => <Screen404 {...props} />}
              />
            </Routes>
          </React.Suspense>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}

export default connect()(App);
